import * as types from '../mutations'
import Vue from 'vue'
import File from 'services/File'

const services = {
  session: window.abp.session,
  settings: window.abp.setting,
  user: window.abp.services.app.user,
  tenant: window.abp.services.app.tenant,
  ajax: window.abp.ajax
}

// initial state
const state = {
  user: {
    emailAddress: ''
  },
  tenant: {
    name: services.settings.get('Userboat.Tenant.Name'),
    description: services.settings.get('Userboat.Tenant.Description'),
    webhookUrl: services.settings.get('Userboat.Tenant.WebhookUrl'),
    image: File.parse(services.settings.get('Userboat.Tenant.Image')),
    stripe: {
      connected: false,
      endpoint: ''
    },
    beeClientId: services.settings.get('Userboat.Tenant.BeeClientId'),
    beeClientSecret: services.settings.get('Userboat.Tenant.BeeClientSecret')
  }
}

// getters
const getters = {
  getCurrentTenant: state => state.tenant,
  getCurrentUser: state => state.user
}

// actions
const actions = {
  getUserSession({ commit }) {
    return new Promise((resolve, reject) => {
      services.user.getCurrentUserSession().done(function (response) {
        commit(types.CORE.RECEIVE_USER_SESSION, response)
        resolve()
      })
    })
  },
  getTenantSession({ commit }) {
    return new Promise((resolve, reject) => {
      services.tenant.getCurrentTenantSession().done(function (response) {
        commit(types.CORE.RECEIVE_TENANT_SESSION, response)
        resolve()
      })
    })
  },
  updateTenant({ commit }, request) {
    let endpoint = Vue.$config('endpoint')
    return new Promise((resolve, reject) => {
      services.ajax({
        url: `${endpoint}/settings/account/details`,
        type: 'POST',
        data: request,
        processData: false,
        contentType: false
      })
        .done(function (response) {
          commit(types.CORE.RECEIVE_TENANT_SESSION, response)
          resolve()
        })
        .fail(function (response) {
          commit(types.DATA.SET_VALIDATION_ERRORS, response)
          reject()
        })
    })
  },
  linkStripe({ commit }, code) {
    return new Promise((resolve, reject) => {
      services.tenant.linkStripe(code).done(function (response) {
        commit(types.CORE.RECEIVE_TENANT_SESSION, response)
        resolve()
      })
    })
  },
  unlinkStripe({ commit }) {
    return new Promise((resolve, reject) => {
      services.tenant.unlinkStripe().done(function (response) {
        commit(types.CORE.RECEIVE_TENANT_SESSION, response)
        resolve()
      })
    })
  }
}

// mutations
const mutations = {
  [types.CORE.RECEIVE_USER_SESSION](state, session) {
    state.user = {
      emailAddress: session.emailAddress
    }
  },
  [types.CORE.RECEIVE_TENANT_SESSION](state, session) {
    state.tenant = {
      name: session.name,
      description: session.description,
      image: session.image,
      beeClientId: session.beeClientId,
      beeClientSecret: session.beeClientSecret,
      webhookUrl: session.webhookUrl,
      stripe: {
        connected: session.isStripeConnected,
        endpoint: session.stripeConnectEndpoint
      }
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./scripts/store/modules/session.js